module.exports = __webpack_public_path__ + "static/06-808f0e7844c445b704d9c7fa9827cf96.jpg";